import React from 'react';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../../../Translator';
import { Select } from '../../../Select';
import Popover from '../../../Popover';
import Button from '../../../Button';
import Tooltip from '../../../Tooltip';
import styles from './ListOptions.module.css';

const bindClasses = classNameBind.bind(styles);

const ListOptions = ({ onCollapseAll, onExpandAll, sort, filters, t }) => (
  <div
    className={bindClasses('wrapper')}
    data-ppuc-id="Sidebar.ListOptions"
  >
    {
      onCollapseAll
        ? (
          <div className={bindClasses('collapse-button')}>
            <Tooltip content={t('Sidebar.ListOptions.CollapseAll')}>
              <Button
                icon="collapse"
                appearance="subdued"
                onClick={onCollapseAll}
                size="small"
                dataId="Sidebar.ListOptions.CollapseAll"
              />
            </Tooltip>
          </div>
        )
        : null
    }
    {
      onExpandAll
        ? (
          <div className={bindClasses('collapse-button')}>
            <Tooltip content={t('Sidebar.ListOptions.ExpandAll')}>
              <Button
                icon="expand"
                appearance="subdued"
                onClick={onExpandAll}
                size="small"
                dataId="Sidebar.ListOptions.ExpandAll"
              />
            </Tooltip>
          </div>
        )
        : null
    }
    {sort
      ? (
        <div className={bindClasses('selector')}>
          <div className={bindClasses('sortSelect')}>
            <Select
              name="Sidebar.ListOptions.Sort"
              options={sort.list}
              value={sort.value}
              onChange={(event) => { sort.onChange(event.target.value); }}
              type="subduedCompactSmall"
              alternativeIcon={{
                icon: 'sort',
              }}
              hideArrowDownIcon
              dataId="Sidebar.ListOptions.Sort"
            />
          </div>
        </div>
      )
      : <div className={bindClasses('spacer')} />
    }
    {filters
      ? (
        <Popover
          position="bottom"
          activatorElement={
            (
              <div className={bindClasses('filtersButton', { active: filters.areActive })}>
                <Button
                  appearance={filters.areActive ? 'primary' : 'subdued'}
                  icon="filter"
                  dataId="Sidebar.ListOptions.Filters"
                  size="small"
                />
              </div>
            )
          }
          subdued={false}
          speechBubble
          hoverTrigger={false}
          noPadding
          {...filters.popoverProps}
        >
          {filters.popoverChildren}
        </Popover>
      ) : null
    }
  </div>
);

export default withTranslation('components')(ListOptions);
